export function initFooterToggle() {
    const footerHeadlines = document.querySelectorAll('.footer__headline');
    
    footerHeadlines.forEach(headline => {
        headline.addEventListener('click', function() {
            if (window.innerWidth < 768) {
                this.classList.toggle('active');
                
                const footerText = this.nextElementSibling;
                if (footerText && footerText.classList.contains('footer__text')) {
                    footerText.classList.toggle('active');
                }
            }
        });
    });
}